SNI.Application.addModule('profile-promo', function(context) {

  return {
    behaviors: ['lazy-load']
  };

});
